// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.down_btn_area > label[data-v-2c60b86b] {\n  margin-left: 0px;\n}\n.txt_border_none[data-v-2c60b86b] {\n  border: none;\n}\n.span_scg[data-v-2c60b86b] {\n  color: #075bb9;\n}\n", ""]);
// Exports
module.exports = exports;
